import { createModule, useLightboxState, type Module } from 'yet-another-react-lightbox';
import type { ExtendedSlide } from 'types/gallery';
import styles from './Gallery.module.scss';

const galleryCounterModule = createModule('GalleryCounter', ({ children }) => {
  const state = useLightboxState();
  const currentSlide: ExtendedSlide | undefined = state.slides[state.currentIndex] as ExtendedSlide;
  const count = currentSlide?.count;
  const totalAmount = currentSlide?.totalAmount;
  return count ? (
    <div className={styles['gallery-counter']}>
      {count} / {totalAmount}
      {children}
    </div>
  ) : null;
});

const CounterPlugin = ({ addChild }: { addChild: (target: string, module: Module) => void }) =>
  addChild('controller', galleryCounterModule);

export default CounterPlugin;
